enum OntarioObstetricalSwabResultEnum {
    None = 0,
    Positive,
    Negative
}

export { OntarioObstetricalSwabResultEnum };
